// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.detail-title[data-v-2816c6d3]{\n  font-size:20px;\n  font-weight:bolder;\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color:#3c3c3c;\n  padding:10px 0 20px 10px;\n  margin:20px 0 15px;\n}\n.detail-title span[data-v-2816c6d3]{\n  display: inline-block;\n  color:#0066CC\n}\n", ""]);
// Exports
module.exports = exports;
